<template lang="pug">
.home
  aside.aside
    .nav
      .system-name(@click="$router.push('/')") 金沙江大桥
        span 除湿数据采集与监视控制系统
      .nav-bar
        .nav-buttom
          router-link(to="/jinshajiang/gasClampCombinedV2") 全桥实时数据
          router-link(to="/jinshajiang/stationMainPlc") 主缆除湿机
          router-link(to="/jinshajiang/stationAnchorPlc") 锚室除湿机
          router-link(to="/jinshajiang/stationSaddlePlc") 鞍室除湿机
          router-link(to="/jinshajiang/currentHumidityList?bridgeId=5afe37e8-98fc-416c-b5e3-26011df7fb39&sortByItemCount=1") 湿度数据清单
          router-link(to="/jinshajiang/currentDataTable?bridgeId=5afe37e8-98fc-416c-b5e3-26011df7fb39") 实时数据表
          router-link(to="/jinshajiang/errorRecord?bridgeId=5afe37e8-98fc-416c-b5e3-26011df7fb39") 报警记录
          router-link(to="/jinshajiang/dataHistory?bridgeId=5afe37e8-98fc-416c-b5e3-26011df7fb39&scenarioId=TBD") 数据历史

  TimeBlock.time-block(bridgeName="YUNNAN", size="radar-size")
  RadarBlock.radar-block1(:daysCount="this.radarBlockDaysCount", :polygonNameDeviceIdListDict="this.radarBlockNameDeviceIdListAnchor"
    , :humidityPassLine="this.radarBlockHumidityLine", title="锚室", ref="radar1", @initComplete="initNextRadar('radar2')"
        , splitLine="dark")
  RadarBlock.radar-block2(:daysCount="this.radarBlockDaysCount", :polygonNameDeviceIdListDict="this.radarBlockNameDeviceIdListSaddle"
    , :humidityPassLine="this.radarBlockHumidityLine", title="鞍室", ref="radar2", :initOnMount="this.radarBlockDelayInit", @initComplete="initNextRadar('radar3')"
        , splitLine="dark")
  RadarBlock.radar-block3(:daysCount="this.radarBlockDaysCount", :polygonNameDeviceIdListDict="this.radarBlockNameDeviceIdListClamp"
    , :humidityPassLine="this.radarBlockHumidityLine", title="气夹", ref="radar3", :initOnMount="this.radarBlockDelayInit", @initComplete="initNextRadar('radar4')"
        , splitLine="dark")
  RadarBlock.radar-block4(:daysCount="this.radarBlockDaysCount", :polygonNameDeviceIdListDict="this.radarBlockNameDeviceIdListMainCableHuaping"
    , :humidityPassLine="this.radarBlockHumidityLine", title="华坪主缆", ref="radar4", :initOnMount="this.radarBlockDelayInit", @initComplete="initNextRadar('radar5')"
        , splitLine="dark")
  RadarBlock.radar-block5(:daysCount="this.radarBlockDaysCount", :polygonNameDeviceIdListDict="this.radarBlockNameDeviceIdListMainCableLijiang"
    , :humidityPassLine="this.radarBlockHumidityLine", title="丽江主缆", ref="radar5", :initOnMount="this.radarBlockDelayInit"
        , splitLine="dark")
</template>

<script>
import TimeBlock from "@/components/TimeBlock";

export default {
  name: "Index",
  components: {
    TimeBlock,
  },
  data() {
    return {
      timer: null,
      bridgeId: "5afe37e8-98fc-416c-b5e3-26011df7fb39",
      historyScenarioList: [],
      radarBlockDaysCount: 3,
      radarBlockHumidityLine: 60,
      radarBlockDelayInit: false,
      radarBlockNameDeviceIdListClamp: {
        "下游进气": [
          "fe7cbbbd-524b-4a66-8908-aeae993929be",
          "e7a76fe8-9c80-4aa8-b762-019084452be9",
          "e3e055cb-7cba-429a-8dcb-dd136f5a8c93",
          "127aa07e-af03-471e-9e61-6e10e3c67f76",
          "b1144cfe-9dc2-4fda-9e2d-44cdde9a7930",
          "8e978520-0b50-4e12-9fce-504ba3ce2936",
        ],
        "下游排气": [
          "64e7910d-befc-4ffd-9250-20d28ca6d078",
          "0ef83c5e-1434-495a-aca6-68608e1fe155",
          "2e7cc90d-43a5-49c5-9822-468793d394f3",
          "4d010112-fb53-4ad8-8163-3dfb3ffb7d37",
          "6a2d8f01-b7f8-49f9-aaea-fe16a9d33f20",
          "12a18e1d-9e4e-4861-bb70-c6d3716f8a5e",
          "e29c1371-60df-4619-98e5-2e0f7e24379e",
          "b9beaec9-d4fa-4866-a8bc-c94056099adf",
          "aac73783-14c2-4c6b-bea9-2291c60619a9",
        ],
        "上游进气": [
          "175a8808-663b-465c-a45d-ac9040a83c6c",
          "19bf6aaa-d59e-4621-a9d5-64c28171ead1",
          "76697d7e-07ad-4a11-9fc1-9e338188acff",
          "8d04e509-24e5-4c10-91da-a92bf4889311",
          "c6e3ee67-14ed-4a19-b869-23a50833d8c0",
          "6ead0e95-4ff5-4d8b-9b41-ef54453dcbd3",
        ],
        "上游排气": [
          "023c7930-4fdc-4c8c-b04b-16cc62e3e899",
          "17e2f31c-3e86-4118-904b-15f8a1592d3d",
          "79cadd01-fa71-471b-880a-d1abc1594687",
          "4e3376a3-d575-4187-b2cf-d7bf0b9c83bd",
          "b8be41df-0112-441b-84c9-976722130b5d",
          "f48b39bd-cfd8-4606-92dd-86cd1bfbb530",
          "398a841f-aed5-4375-9375-97d575bf7824",
          "ef6a9e20-40e3-4dd2-a78b-3612a5c3b574",
          "90ae78c7-542d-45cc-81d4-fd24083a71f5",
        ],
      },
      radarBlockNameDeviceIdListAnchor: {
        "华坪上游": [
          "5c2dab2d-f45e-45ea-9da4-8b398b114b28"
        ],
        "华坪下游": [
          "d4e84dcb-b8f3-442b-8984-0946a0d0e9f5"
        ],
        "丽江上游": [
          "719d1f76-5a17-4b34-ad9f-affbc312ee98"
        ],
        "丽江下游": [
          "b5269f1c-e44e-4e2c-a035-5c69b4523fe8"
        ],
      },
      radarBlockNameDeviceIdListSaddle: {
        "华坪上游": [
          "4002431e-8b97-459a-9e4b-5454e143023b"
        ],
        "华坪下游": [
          "f4eed4a2-c3b2-41e0-87d0-f83c0c078f73"
        ],
        "丽江上游": [
          "79e95616-000b-4c13-8b80-52eb48f5228b"
        ],
        "丽江下游": [
          "8b315c32-2871-4c97-b6bf-e2430b9166f4"
        ],
      },
      radarBlockNameDeviceIdListMainCableHuaping: {
        "JM3出口": [
          "8df2cbb2-51e1-4fb0-904b-bffc8493dbcb"
        ],
        "JW1出口": [
          "e17dcddb-55ca-4e1b-a34a-7eb500b29672"
        ],
        "JM1出口": [
          "c4390ed5-5b7b-42f3-a8ed-3cd2817aa8dc"
        ],
        "JW2出口": [
          "d31bacde-ed19-4487-849e-a8a7325d2318"
        ],
        "JM2出口": [
          "e12a7406-66c3-49d2-a4ab-97676731538d"
        ],
        "JM4出口": [
          "7a527200-21df-4e00-8064-c224e854c641"
        ],
      },
      radarBlockNameDeviceIdListMainCableLijiang: {
        "JM5出口": [
          "d2dfe703-e0d0-4ce3-9d53-6d1fdbce2022"
        ],
        "JM7出口": [
          "176c7d9e-ab15-454f-8b73-964441c2f048"
        ],
        "JM8出口": [
          "f713a91f-e173-431f-b379-407fc31286bf"
        ],
        "JE2出口": [
          "58597ca8-c2c5-4e3f-a194-c9af44e5c8cb"
        ],
        "JM6出口": [
          "97c49c13-d8e2-4390-9721-da715f8d1fa3"
        ],
        "JE1出口": [
          "cafba24d-b702-4fbc-ae76-44b2f6c69135"
        ],
      },
    };
  },
  computed: {},
  mounted() {
    this.timer = setInterval(() => {
      this.checkAuth();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    checkAuth() {
      this.$http.get("/auth/LoginInfo").then((res) => { });
    },
    initNextRadar(refName) {
      let radar = this.$refs[refName];
      if (radar) {
        setTimeout(() => {
          radar.initChart();
        }, 1000);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
  height: 100%;
  min-height: 600px;
  position: relative;
  background: url("../../assets/image/jinshajiang/jinshajiang.jpg") center no-repeat;
  background-size: cover;

  .time-block {
    position: absolute;
    top: 100px;
    right: 150px;
  }

  .radar-block1 {
    position: absolute;
    top: 100px;
    right: 650px;
  }

  .radar-block2 {
    position: absolute;
    top: 100px;
    right: 400px;
  }

  .radar-block3 {
    position: absolute;
    top: 280px;
    right: 650px;
  }

  .radar-block4 {
    position: absolute;
    top: 280px;
    right: 400px;
  }

  .radar-block5 {
    position: absolute;
    top: 280px;
    right: 150px;
  }

  .aside {
    position: relative;
    width: 250px;
    height: 100%;
    color: #fff;
    min-width: 260px;
    text-align: center;
    box-shadow: 0 0 30px 0 #000;
    overflow: hidden;
    box-sizing: border-box;
    background: url("../../assets/image/jinshajiang/jinshajiang1.jpg") center no-repeat fixed;
    background-size: cover;

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      background: transparent;
    }

    ::-webkit-scrollbar-corner {
      background: transparent;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background-color: #84a4c2;
    }

    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
      border-radius: 0;
      background-color: transparent;
    }

    .nav {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      z-index: 1;

      a {
        display: block;
        width: 58%;
        height: 48px;
        margin: 0 auto 20px auto;
        border: none;
        line-height: 48px;
        border-radius: 5px;
        color: #4b4e50;
        background: #cadce9;
        cursor: pointer;
        text-decoration: none;

        &.same-line {
          display: flex;
          flex-direction: column;
          justify-content: center;
          line-height: 18px;
        }

        p {
          margin: 0;
        }

        &:hover {
          color: #fff;
          background: #33a2f5;
        }
      }

      .system-name {
        height: 75px;
        font-weight: 700;
        font-size: 40px;
        margin: 75px 0;
        cursor: pointer;

        span {
          display: block;
          font-size: 18px;
        }
      }

      .nav-bar {
        height: calc(100% - 250px);
        overflow-y: auto;
      }
    }
  }
}
</style>